import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { ErrorBoundary } from 'react-error-boundary';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Backdrop, CircularProgress } from '@material-ui/core';
import ptLocale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import useStore from './services/hooks/useStore';
import X9Logger from './services/X9Logger';
import Notificacao from './components/Notificacao';
import Drawer from './components/Drawer';
import NavBar from './components/NavBar';
import ModalAlterarSenha from './components/Modais/AlterarSenha';
import Login from './pages/Login';
import ErroExecucao from './pages/Erros/ErroExecucao';
import { Flex } from './components/NavBar/styles';
import checkUser from './middlewares/checkUser';
import Routes from './routes';
import ReactGa from 'react-ga';
// import startMockServer from './services/APIMock';
// eslint-disable-next-line
import { useClearCache } from 'react-clear-cache';
import RecuperarSenha from './pages/Auth/RecuperarSenha';

const App: React.FC = () => {
  const { isLatestVersion, emptyCacheStorage } = useClearCache();
  const store = useStore();

  useEffect(() => {
    if (!isLatestVersion) {
      emptyCacheStorage();
    }
  }, [isLatestVersion, emptyCacheStorage]);

  useEffect(() => {
    const path = window.location.pathname;
    if (path !== '/' && !path.startsWith('/auth/')) {
      checkUser();
    } else {
      store.removeLoader();
    }
    ReactGa.initialize('UA-148724062-2');
    ReactGa.pageview(window.location.pathname + window.location.search);
    // eslint-disable-next-line
    // startMockServer();
  }, []);
  useEffect(() => {
    // Adiciona o script do widget
    const script = document.createElement('script');
    script.src = 'https://www.cepea.org.br/br/widgetproduto.js.php?fonte=arial&tamanho=10&largura=400px&corfundo=dbd6b2&cortexto=333333&corlinha=ede7bf&id_indicador[]=349-MG&id_indicador[]=349-NP&id_indicador[]=349-OP';
    script.async = true;

   
    document.body.appendChild(script);

    // Tenta extrair os dados depois que o widget for renderizado
    const interval = setInterval(() => {
      
   


      const tabela = document.querySelector('.imagenet-widget-tabela') as HTMLTableElement | null;
     

      if (!tabela) {
        
        return;
      }

      const rows = tabela.querySelectorAll('tbody tr');
  

      if (rows && rows.length > 0) {
        const formatarData = (dataString: string) => {
          const [dia, mes, ano] = dataString.split('/');
          const data = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
          return new Intl.DateTimeFormat('pt-BR', { month: 'short', year: 'numeric' })
            .format(data)
            .replace(' de ', '/').replace('.', '');
        };

        const resultados: { produto: string; preco: string, data: string }[] = [];
        rows.forEach((row) => {
          
          const cells = row.querySelectorAll('td');
          if (cells.length >= 3) {
            const dataOriginal = cells[0]?.innerText.trim();
            const produto = cells[1]?.innerText.trim();
            const preco = cells[2]?.innerText.trim();

            if (produto && preco) {
              resultados.push({
                produto: `${produto}`,
                preco: `R$/KG ${preco.replace('R$', '')}`,
                data: formatarData(dataOriginal)
              });
            }
          }
        });

       localStorage.setItem('dados', JSON.stringify(resultados));
     
        clearInterval(interval);
      }
    }, 1000); // Aumentei o intervalo para 1 segundo

    return () => {
      clearInterval(interval);
      // Remove o script ao desmontar
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);


  return (
    <ErrorBoundary FallbackComponent={ErroExecucao} onError={X9Logger.report}>
      <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils}>
        <Router>
          <Switch>
            <Route exact path="/auth/recuperar-senha" component={RecuperarSenha} />
            <Route exact path="/" component={Login} />
            <Route path="/">
              <>
                <NavBar />
                <div className="flex">
                  <Drawer />
                  <div className="content">
                    <Routes />
                  </div>
                </div>
              </>
            </Route>
          </Switch>

          <Notificacao />
          <ModalAlterarSenha open={store.modalAlterarSenha} handleClose={store.toggleModalAlterarSenha} />
          <Backdrop className="loader" open={store.loader}>
            <Flex style={{ flexDirection: 'column' }}>
              <CircularProgress />
              <br />
              {!store.logado ? (
                <p style={{ color: 'white' }}>Validando credenciais</p>
              ) : (
                <p style={{ color: 'white' }}>Carregando dados</p>
              )}
            </Flex>
          </Backdrop>
        </Router>
      </MuiPickersUtilsProvider>
    </ErrorBoundary>
  );
};

export default observer(App);
